import React, {useState, useEffect} from 'react';
import {FilePreviewContainer} from '@common/uploads/preview/file-preview-container';
import {useShareableLinkPage} from '../queries/use-shareable-link-page';
import {ShareableLinkNavbar} from './shareable-link-navbar';
import {AdHost} from '@common/admin/ads/ad-host';
import {FormSwitch} from '@common/ui/forms/toggle/switch';
import {Trans} from '@common/i18n/trans';
import { useForm } from 'react-hook-form';
import {apiClient, queryClient} from '@common/http/query-client';
import {getCookie, setCookie} from 'react-use-cookie';

export function ShareableLinkPageFilePreview() {
  const {link} = useShareableLinkPage();  

  if (!link?.entry) return null;

  const [inputField , setInputField] = useState({
    name: '',
    email: '',
    phone: '',
    statusMsg: ''
  });

  const [formProcessing , setFormProcessing] = useState(false);
  const [hideOverlay , setHideOverlay] = useState(false);

  useEffect(() => {
    if(link && typeof link.hash){
      let linkHashCookie = getCookie(link.hash);
      if(linkHashCookie && linkHashCookie == '1'){
        setHideOverlay(true);
      }
    }
  }, [link]);

  const inputsHandler = (e:any) =>{
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  const submitForm = (e:any) =>{
    e.preventDefault();
    // console.log(inputField);
    let name = inputField.name;
    let email = inputField.email;
    let phone = inputField.phone;

    //Send mail to admin team with details
    let payload = {
      name: name,
      email: email,
      phone: phone,
      link: link
    }

    setFormProcessing(true);
    apiClient.post('shareFileAccess', payload).then(r => {
      setFormProcessing(false);
      if(typeof r.status != 'undefined' && r.status == 200){
        if(typeof r.data.msg != 'undefined' && r.data.msg == 'success'){
          setInputField((prevState) => ({
            ...prevState,
            ['statusMsg']: '<div class="successAlert">Information submitted successfully</div>',
          }));          
          
          setCookie(link.hash, '1', {
            days: 7
          });

          setTimeout(() => {
            setHideOverlay(true);
          }, 2000);
        } else {
          setInputField((prevState) => ({
            ...prevState,
            ['statusMsg']: '<div class="errorAlert">Error in processing. Try again.</div>',
          }));
        }
      } else {
        setInputField((prevState) => ({
          ...prevState,
          ['statusMsg']: '<div class="errorAlert">Error in processing. Try again.</div>',
        }));
      }
    }).catch(function (error) {
      setFormProcessing(false);
      setInputField((prevState) => ({
        ...prevState,
        ['statusMsg']: '<div class="errorAlert">Error in processing. Try again.</div>',
      }));
    });
  }

  return (
    <div className="flex h-screen flex-col bg-alt">
      <ShareableLinkNavbar />
      <AdHost slot="file-preview" className="mx-auto mt-24" />
      <FilePreviewContainer
        entries={[link.entry]}
        showHeader={false}
        allowDownload={link.allow_download}
      />
      
      <div className={"overlayAgreement "+(hideOverlay == true ? 'hide' : '')}>
        <form name="agreementForm" onSubmit={e => submitForm(e)}>
          <div className="bg-white shadow-md rounded p-20 flex flex-col">
            <div className="submitStatus" dangerouslySetInnerHTML={{__html: inputField.statusMsg}}/>
            <div className="items-center gap-10 font-semibold pb-20 text-main justify-between" style={{textAlign: 'center'}}>
              <h2 style={{fontSize: '30px', display: 'block'}}>Welcome</h2>
              <p id=":r1s:-label" className="mr-auto leading-5 opacity-90">Get ready to access the files instantly by completing our digital confidentiality agreement</p>
            </div>
            <div className="-mx-3 md:flex mb-6">
                <div className="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block first-letter:capitalize text-left whitespace-nowrap text-sm mb-4">Name*</label>
                    <input className="block text-left relative w-full appearance-none transition-shadow text bg-transparent rounded-input border-divider border focus:ring focus:ring-primary/focus focus:border-primary/60 focus:outline-none shadow-sm text-sm h-42 pl-12 pr-12"
                    id="name" name="name" type="text" placeholder="Enter your name" required onChange={inputsHandler} value={inputField.name}/>
                </div>
                <div className="md:w-1/2 px-3">
                    <label className="block first-letter:capitalize text-left whitespace-nowrap text-sm mb-4">Phone no.*</label>
                    <input className="block text-left relative w-full appearance-none transition-shadow text bg-transparent rounded-input border-divider border focus:ring focus:ring-primary/focus focus:border-primary/60 focus:outline-none shadow-sm text-sm h-42 pl-12 pr-12"
                    id="phone" name="phone" type="text" placeholder="Enter your phone no." required onChange={inputsHandler} value={inputField.phone}/>
                </div>
            </div>
            <div className="-mx-3 md:flex mb-6">
                <div className="md:w-full px-3">
                    <label className="block first-letter:capitalize text-left whitespace-nowrap text-sm mb-4">Email*</label>
                    <input className="block text-left relative w-full appearance-none transition-shadow text bg-transparent rounded-input border-divider border focus:ring focus:ring-primary/focus focus:border-primary/60 focus:outline-none shadow-sm text-sm h-42 pl-12 pr-12"
                    id="email" name="email" type="text" placeholder="Enter your email address" required onChange={inputsHandler} value={inputField.email}/>
                </div>
            </div>
            <div><span className="text-red-500 text-xs italic">All fields are mandatory</span></div>
            <div className="-mx-3 md:flex mb-6 mt-10">
              <div className="md:w-full px-3">
                <input type="checkbox" name="agree_to_terms" id="agree_to_terms" required/>
                <label className="pl-8" htmlFor="agree_to_terms">I agree to the <a className="underline" href="/pages/confidentiality-agreement">Confidentiality Agreement</a> of the site</label>
              </div>
            </div>
            <div className="-mx-3 md:flex mt-2 mt-20 text-right">
                <div className="md:w-full px-3">
                    <button disabled={formProcessing} className={"focus-visible:ring text-on-primary bg-primary border border-primary hover:bg-primary-dark hover:border-primary-dark disabled:text-disabled disabled:bg-disabled disabled:border-transparent disabled:shadow-none whitespace-nowrap inline-flex align-middle flex-shrink-0 items-center transition-button duration-200 select-none appearance-none no-underline outline-none disabled:pointer-events-none disabled:cursor-default rounded-button justify-center font-semibold text-sm h-36 px-18"}>Agree</button>
                </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
